export default {"src":"/_next/static/media/Asset-36.bba85b47.svg","height":404,"width":392,"blurWidth":0,"blurHeight":0};